<template>
  <div class="indicators">
    <div class="indicator" v-for="(indicator, index) in indicators" :key="index">
      <p class="is-size-4 is-size-3-desktop has-text-weight-bold">{{ indicator.value | local }}</p>
      <p class="heading">{{ indicator.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    indicators: {
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.indicators {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1 0 100%;
}
.indicator {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
